export class UpsertEventTemplateRequest {
  EventWorkflowID?: number;
  TemplateName = '';
  MainAuditID = -1;
  LocationQuestionID = -1;
  DateQuestionID = -1;
  TypeQuestionID = -1;
  SummaryQuestionID = -1;
  RiskQuestionID = -1;
  Active = true;
  LocationIDs: number[] | undefined;
}
